import React, { useEffect } from 'react';
import { Button, CloseButton, DialogActions } from 'pages/TimeClock/modals/base/styled';
import { DialogTitle, DialogDescription, ExportForm, Dialog } from './styled';
import useExcelExport from './hooks/useExcelExport';
import { subDays } from 'date-fns';

const ExportSheetMaterialsExcelModal = ({ open, onClose, withEquipment }) => {
  const { isExported, setIsExported, onDownload } = useExcelExport(withEquipment);

  useEffect(() => {
    if (open) {
      setIsExported({
        period: {
          from: subDays(new Date(), 14),
          to: new Date(),
        },
        jobNumber: [],
        cl: [],
        materialName: [],
        materialUnit: [],
        materialColor: [],
        materialSpecification: [],
        lineWidth: [],
        legendSymbol: [],
        letteringText: [],
        letteringParameters: [],
        equipment: [],
      });
    }
  }, [open])

  const handleClose = () => {
    setIsExported(null);
    onClose();
  }
  const handleCancel = () => {
    setIsExported(null);
    onClose();
  }
  const handleSubmit = () => {
    onDownload();
    onClose();
  }
  const handleChange = (value) => {
    setIsExported(value);
  }

  return (
    <Dialog open={open}>
      <CloseButton onClick={handleClose} />
      <DialogTitle disableTypography={true}>Excel export</DialogTitle>
      <DialogDescription>
        Select a date period to export. <br />
        Exports a date period including the day selected.
      </DialogDescription>
      {isExported && <ExportForm value={isExported} onChange={handleChange} withEquipment={withEquipment} />}
      <DialogActions disableSpacing={false} style={{padding: '0 26px 20px'}}>
        <Button
          variant={'outlined'}
          color={'secondary'}
          fullWidth={true}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button variant={'outlined'} fullWidth={true} onClick={handleSubmit}>
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportSheetMaterialsExcelModal;
